<template>
  <div>
    <FormFieldLabel v-if="label" :for="name">
      {{ label }}
    </FormFieldLabel>

    <input
      type="datetime-local"
      :name="name"
      :class="[
        'block w-full rounded-md border border-background-fg/8 text-base font-semibold focus:outline-none', // Font size set at >14px (text-base) so no zoom on mobile when focused
        hasError
          ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
          : 'focus:border-primary focus:ring-primary',
      ]"
      :placeholder="placeholder"
      :value="inputValue"
      :aria-invalid="hasError"
      enterkeyhint="done"
      :disabled="disabled"
      @change="handleChange"
      @blur="handleBlur"
    />

    <p
      v-if="hasError"
      class="mt-1 text-xs font-medium text-error"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = withDefaults(
  defineProps<{
    name: string
    label: string
    placeholder?: string
    disabled?: boolean
  }>(),
  {
    placeholder: "",
    disabled: false,
    maxlength: undefined,
  }
)

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
} = useField(name)

const hasError = computed(() => !!errorMessage.value)
</script>
